<template>
<!--我的订单-->
  <div class="orders">
    <headers></headers>
    <div class="nav">
      <div class="auto">学分认定  >  学分认定指南  >  实名认证  >  证书查询  >  我的证书  >  学分认定 </div>
    </div>
    <div class="padding250 auto">
       <p class="title">学分认定</p>
      <div class="container">

        <div class="content">
          <p class="title"><img src="../../assets/xuefenlogo.png" alt=""></p>
          <ul>
          	<li><span>兹证明</span> 王小东</li>
            <li><span>所持有的</span><p><span>全国物业行业项目经理职业资格证书</span> 具有兑换学分的资格</p></li>
            <li><span>证书编号</span> 110102295637900</li>
            <li><span>学分对应科目</span> <p>物业项目运营管理(非统设选修)</p></li>
            <li><span>学分认定证书</span><p>全国物业行业项目经理职业资格证书</p> </li>
            <li><span>认定学分</span> 5分</li>
            <li><span>认定证明有效期</span><p>2019年10月20日 <br>2019年10月20日</p> </li>
          </ul>
        </div>
        <p>
           <router-link to="/jiaofei" style="display: none;">确认学分认定</router-link>
           <router-link to="/rendingsuccess">确认学分认定</router-link>
          <router-link to="/" class="save" style="display: none;"><img src="../../assets/download.png" alt="" width="22">保存相册</router-link>
        </p>

      </div>
    </div>
<footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .container{
     background-color: #fff;
      padding: 50px 0;
      margin-top: 20px;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    text-align: left;
    .auto{
      margin-top: 0;
    }
  }
 .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
      text-align: left;
    }
  .content{
   background: url('../../assets/zhengshubg.png') no-repeat;
   width: 490px;
   height: 626px;
    padding-top: 50px;
    margin:0px auto 50px;
    text-align: left;
   .title{
      font-size: 30px;
      color: #333;

      margin:35px auto;
      text-align: center;
      // width: 240px;
      font-weight: 700;
   }
   li{
      font-size: 17px;
      color: #666;
      padding:0 60px;
      margin-bottom: 12px;
      span{
        color: #000;
        display: inline-block;
        width: 135px;
      }
      p{
        width: 224px;
        vertical-align: top;
        display: inline-block;
        span{
          color: #244068;
          display: inline;
        }
      }
   }
  }
  a{
    color: #fff ;
    font-size: 16px;
    background-color: #957960;
    display: block;
    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px;
    margin: auto;
    img{
      vertical-align: middle;
      margin-right: 10px;
    }
  }
.save{
  border-radius: 50px;
}



</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {


            };
        },
        methods: {

        },
        created() {

        },
        components: {
          headers,
          footers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/xuefendetail.vue